var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.167,
    height: 31.167,
    viewBox: "0 0 31.167 31.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(0 1365.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 -1365.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M31.167-1349.747a15.584,15.584,0,0,0-15.584-15.584A15.584,15.584,0,0,0,0-1349.747a15.587,15.587,0,0,0,13.149,15.394v-10.89H9.192v-4.5h3.957v-3.433c0-3.906,2.327-6.063,5.886-6.063a23.959,23.959,0,0,1,3.488.3v3.835H20.558a2.252,2.252,0,0,0-2.54,2.434v2.923h4.322l-.691,4.5H18.019v10.89a15.587,15.587,0,0,0,13.149-15.394",
    transform: "translate(0 1365.33)",
    fill: "#1877f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M415.123-1084.663l.691-4.5h-4.322v-2.923a2.252,2.252,0,0,1,2.54-2.434H416v-3.835a23.958,23.958,0,0,0-3.488-.3c-3.56,0-5.886,2.157-5.886,6.063v3.433h-3.957v4.5h3.957v10.89a15.7,15.7,0,0,0,2.435.189,15.7,15.7,0,0,0,2.435-.189v-10.89h3.631",
    transform: "translate(-393.474 1104.751)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.49cafe99e70ccfa2e634400058cc0ce9.svg";
export { ForwardRef as ReactComponent };